/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BranchDto } from '../../models/branch-dto';

export interface BranchAdminControllerFindAllV1$Params {
}

export function branchAdminControllerFindAllV1(http: HttpClient, rootUrl: string, params?: BranchAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BranchDto>>> {
  const rb = new RequestBuilder(rootUrl, branchAdminControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BranchDto>>;
    })
  );
}

branchAdminControllerFindAllV1.PATH = '/api/v1/branches/admin';
